// removed by extract-text-webpack-plugin
module.exports = {"status-banner":"status-banner___1vZz3","reserve":"reserve___Dle05","reserve-dispute-text":"reserve-dispute-text___3vPAq","cta":"cta___2GAr9","container":"container___3OX-l","link":"link___1S1kJ","cta-text":"cta-text___15npL","leading-bidder-bar":"leading-bidder-bar___1PEQo","button-container":"button-container___1eh-m","button":"button___3T6pr","bid-live-message":"bid-live-message___1_TwZ","light":"light___voswB","message":"message___2s-6F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusBanner/StatusBanner.scss
// module id = LtPH
// module chunks = 57